export default __webpack_public_path__ + "static/cstorey-033961a95830a77327fe7f136300b108.png";